"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

class GLHorizontalFilterNode {
  constructor(filters, currentSelectedIndex = 0) {
    this.filters = filters;
    this.currentSelectedIndex = currentSelectedIndex;
  }

  getSelectedIndex() {
    return this.currentSelectedIndex;
  }

  setSelected(index) {
    if (this.filters.length > index && index >= 0) {
      this.currentSelectedIndex = index;
    }
  }

  getSelectedFilter() {
    return this.filters.length > this.currentSelectedIndex ? this.filters[this.currentSelectedIndex] : null;
  }

  initialize(gl) {
    this.filters.forEach(filter => filter.initialize(gl));
  }

  setViewSize(gl, width, height) {
    this.filters.forEach(filter => filter.setViewSize(gl, width, height));
  }

  setSize(gl, width, height) {
    this.filters.forEach(filterOption => filterOption.setSize(gl, width, height));
  }

  get outputTextureWidth() {
    let width = 0;

    for (const filter of this.filters) {
      width = Math.max(filter.outputTextureWidth, width);
    }

    return width;
  }

  get outputTextureHeight() {
    let height = 0;

    for (const filter of this.filters) {
      height = Math.max(filter.outputTextureHeight, height);
    }

    return height;
  }

  draw(gl, texture, flip) {
    if (this.filters.length > this.currentSelectedIndex && this.filters[this.currentSelectedIndex]) {
      this.filters[this.currentSelectedIndex].draw(gl, texture, false, flip);
    }
  }

}

exports.default = GLHorizontalFilterNode;